import { Component, OnInit } from '@angular/core';
import { FileFormService } from 'src/app/_services/file-form.service';

@Component({
  selector: 'DCO-file-form',
  templateUrl: './file-form.component.html',
  standalone: false,
})
export class FileFormComponent implements OnInit {

  dynamicForm: any;
  responses: any = {};

  constructor(
    private fileFormService: FileFormService
  ) {}

  ngOnInit(): void {
    this.loadDynamicFormData();
  }

  //Load the DynamiFormn data from fileFormService service
  loadDynamicFormData() {
    const dynamicFormId = 8354;
    const claimOperationId = 22200;

    this.fileFormService.GetDynamicForm(dynamicFormId, claimOperationId).subscribe({
      next: (response) => {
        this.dynamicForm = response.dynamicForm;
        this.responses =   response.dynamicForm['responseObject'];
      },
      error: (error) => {
        console.error('Error fetching dynamic form data:', error);
      }
    });
  }

  //Determine(dinamically) the input type to be rendered in the form based on `controlTypeName`
  getControlType(questionDisp: any): { type: string, inputType: string } {
    const controlType = questionDisp.question.controlTypeName.toLowerCase();
    let type = 'default';
    let inputType = 'text';

    if (controlType.includes('dropdown')) {
      type = 'dropdown';
    } else if (controlType.includes('textboxnumeric')) {
      type = 'input';
      inputType = 'number';
    } else if (controlType.includes('datepicker')) {
      type = 'input';
      inputType = 'date';
    } else if (controlType.includes('textbox')) {
      type = 'input';
      inputType = 'text';
    }
    return { type, inputType };
  }

  //transform the value and text string to a iterable structure to be the options list into dropdown
  getControlTypeOptions(questionDisp: any): any[] {
    const controlValue = questionDisp.question.controlValueString;
    const controlText = questionDisp.question.controlTextString;

    if (controlValue && controlText) {
      const valuesArray = controlValue.split('#');
      const textArray = controlText.split('#');

      return [{
        content: valuesArray.map((value: any, idx: number) => ({
          text: textArray[idx],
          value: value
        }))
      }];
    }
    return [];
  }

  //Determine if a question must be visible or not based in the ruleConditionStructureKeys content
  checkQuestionVisibility(question: any): boolean {
    if (question.ruleConditionStructureKeys) {
      const orConditions = question.ruleConditionStructureKeys.split('|');

      for (let condition of orConditions) {
        const andConditions = condition.split('&');
        const allAndConditionsMet = andConditions.every((cond: string) => this.checkCondition(cond));
        if (allAndConditionsMet) {
          return true;
        }
      }
      return false;
    }
    return question.visible || !question.ruleConditionStructureKeys;
  }

  //check a specific condition to determine an specific visibility rule
  checkCondition(condition: string): boolean {
    const [key, value] = condition.split('=');
    return this.responses[key] === value;
  }

  //Handle the selecction in dropdowns and update the answers
  OnSelectDDL(key: string | number,value: any){
    // console.log(this.responses);
    this.responses[key]=value;
  }

  onSaveResponses() {
    // console.log('Final Responses Saved:', this.responses);
  }

}
